import { Component, Input } from '@angular/core';
import { TrackByUtilities } from '@utilities/trackByFn.utilities';
import { IncentivizedProcedure } from '@interfaces/incentivized-procedure.model';
import { TermAutosuggest } from '@classes/term-autosuggest.class';
import { GoogleTagManagerService } from '@services/analytics/google-tag-manager.service';

@Component({
  selector: 'app-rts-welcome-banner',
  templateUrl: './rts-welcome-banner.component.html',
  styleUrls: ['./rts-welcome-banner.component.scss'],
})
export class RtsWelcomeBannerComponent {
  @Input() public procedures: IncentivizedProcedure[];

  public trackById: any = TrackByUtilities.trackByFnItemId;

  constructor(
    private googleTagManager: GoogleTagManagerService,
    private termAutosuggest: TermAutosuggest
  ) {}

  public searchProcedure(procedure: IncentivizedProcedure): void {
    this.gtmTagFacilitiesClick(procedure.name);
    scrollTo(0, 0); // Scroll to top
    this.termAutosuggest.searchRtsProcedure(procedure.id);
  }

  private gtmTagFacilitiesClick(name: string): void {
    this.googleTagManager.pushToDataLayer({
      event: 'gtm.rts.homepage_facilities',
      procedure_name: name,
    });
  }
}
